import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import GridTable from "../table/gridTable";
import useCurrency from "../../hooks/useCurrency";
import { submitPayout } from "../../store/actions/disbursement/submitPayout";
import { submitRealEstatePayout } from "../../store/actions/disbursement/submitRealEstatePayout";
import { getServerDate } from "../../config/dateformatter";
import { getRealEstatePayoutHistory } from "../../store/actions/investment/getRealEstatePayoutHistory";
import { submitManualPayout } from "../../store/actions/disbursement/submitManualPayout";
import { submitProportionalPayout } from "../../store/actions/disbursement/submitProportionalPayout";
import { submitMudarabahPayout } from "../../store/actions/disbursement/submitMudarabahPayout";
import { buildMudarabahPayload } from "../../Helper/mudarabahPayout";

const SelectMember = ({
  open,
  invID,
  type,
  refresh,
  onClose,
  onCloseParent,
  cycle,
  setButtonText,
  percentage,
  form,
}) => {
  const [loading, setLoading] = useState(false);
  const investment = useSelector((state) => state?.investment?.investment);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const [_currency, getAmount] = useCurrency();
  const dispatch = useDispatch();
  const columns = [
    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
      renderCell: (params) =>
        params.row?.user
          ? params.row?.user.name?.split(" ")[0]
          : params.row?.name?.split(" ")[0],
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 150,
      renderCell: (params) =>
        params.row?.user
          ? params.row?.user.name?.split(" ")[1]
          : params.row?.name?.split(" ")[1],
    },

    {
      field: "Email",
      headerName: "Email",
      width: 80,
      // renderCell: (params) => percentage,
      renderCell: (params) =>
        params.row?.user ? params.row?.user.email : params.row?.email,
    },
  ];

  const rows =
    cycle?.investors ||
    investment?.investments ||
    investment?.investors?.map((investor) => ({
      ...investor,
      user_id: investor?.id,
    }));

  const handlePayout = (beneficiaries) => {
    setLoading(true);

    let data = {};
    if (cycle) {
      data.cycle_id = cycle?.id;
      data.investment_product_id = cycle?.investment_id;
    }

    if (type === "Mudarabah") {
      dispatch(
        submitMudarabahPayout({
          data: buildMudarabahPayload({
            values: form?.values,
            cycle,
            invID,
            beneficiaries,
          }),
          callback: () => {
            onCloseParent();
            refresh && refresh();
            onClose(false);
          },
          fail: () => {
            form.setSubmitting(false);
            setLoading(false);
          },
        }),
      );
    } else if (type === "Manual") {
      dispatch(
        submitManualPayout({
          data: {
            cycle_id: cycle?.id,
            investment_product_id: cycle?.investment_id,
            disbursement_date: getServerDate(form?.values?.disbursement_date),
            profit_amount: form?.values?.profit_amount,
            beneficiaries,
          },
          callback: () => {
            onCloseParent();
            dispatch(
              getRealEstatePayoutHistory({
                id: invID,
                cycle_id: cycle?.id,
                callback: () => {},
                fail: () => {},
              }),
            );
            onClose(false);
          },
          fail: () => {
            setLoading(false);
          },
        }),
      );
    } else if (type === "Real Estate") {
      dispatch(
        submitRealEstatePayout({
          data: {
            property_product_id: invID,
            disbursement_date: getServerDate(form?.values?.disbursement_date),
            profit_amount: form?.values?.profit_amount,
            repayment_type: form?.values?.repayment_type?.value,
            capital_amount: form?.values?.capital_amount,
            beneficiaries,
          },
          callback: () => {
            onCloseParent();
            dispatch(
              getRealEstatePayoutHistory({
                id: invID,
                cycle_id: cycle?.id,
                callback: () => {},
                fail: () => {},
              }),
            );
            onClose(false);
          },
          fail: () => {
            setLoading(false);
          },
        }),
      );
    } else if (
      form?.values?.repayment_type?.value &&
      form?.values?.payout_type?.value
    ) {
      dispatch(
        submitProportionalPayout({
          data: {
            repayment_type: form?.values?.repayment_type?.value,
            payout_type: form?.values?.payout_type?.value,
            amount_to_disburse: form?.values?.amount_to_disburse,
            // payment_schedule_id:
            //   form?.values?.paymentSchedulesValue ||
            //   form?.values?.paymentSchedules?.id,
            beneficiaries,
            expected_date_id: form?.values?.paymentSchedules?.value,
            ...data,
          },
          callback: () => {
            onCloseParent();
            refresh();
            onClose(false);
          },
          fail: () => {
            form.setSubmitting(false);
            setLoading(false);
          },
        }),
      );
    } else {
      dispatch(
        submitPayout({
          data: {
            payment_schedule_id:
              form?.values?.paymentSchedulesValue ||
              form?.values?.paymentSchedules?.id,
            beneficiaries,
            expected_date_id: form?.values?.paymentSchedules?.value,
            ...data,
          },
          callback: () => {
            onCloseParent();
            refresh();
            onClose(false);
          },
          fail: () => {
            form.setSubmitting(false);
            setLoading(false);
          },
        }),
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full ">
          <img src="/Assets/approveIcon.png" alt="" className="w-12 h-12 " />
          <div>
            <h1 className="font-semibold text-2xl mt-4 mb-4">Select Users</h1>
            <p className="text-sm mb-4 w-[432px]">
              Are you sure you want to make this payout
            </p>
            <div className="h-[270px] overflow-scroll w-full items-center mr-4">
              <GridTable
                noSearch={true}
                rows={rows?.map((row) => ({ ...row, id: row?.user_id }))}
                columns={columns}
                disableRowSelectionOnClick={false}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
                handleRowClick={(params, event) => {}}
              />
            </div>
            <div className="flex mt-4 w-full justify-center items-center">
              <CustomButton
                variant="outlined"
                customColor="#fff"
                children="Cancel"
                width="100%"
                onClick={onClose}
                height="50px"
                borderColor="#D0D5DD"
                margin="0px 20px 0px 0px"
                color="#159AA8"
                iconWidth="22px"
              />

              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children="Payout Users"
                width="100%"
                loading={loading}
                height="50px"
                // disabled={rowSelectionModel?.length < 1}
                padding="10px"
                onClick={() => handlePayout(rowSelectionModel)}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default SelectMember;
